import { combineReducers } from 'redux';
import epgTransactions from './epgTransactions.reducer';

export default combineReducers({
  epgTransactions,
});
